import Banner from 'components/Banner';
import GradientText from 'components/GradientText';
import NewsCards from 'components/NewsCards';
import TagsFilter from 'components/TagsFilter';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlog, fetchPostsForNews, selectBlogPage, selectPostForNews } from 'store/slices/BlogSlice';
import { useEffect } from 'react';
import React from 'react';
import ButtonShowMore from 'components/Button/ButtonShowMore';
import { scrollToSection } from 'helpers';
import { selectPostsTypeTranslations } from 'store/slices/GeneralTranslationsSlice';

const allType = 'all';

const News = () => {
    const dispatch = useDispatch();
    const [selectedTag, setSelectedTag] = React.useState(undefined);
    const [page, setPage] = React.useState(1);

    const { title, description, tags, title_background, show_all_button, show_more_button, fs_button_text } =
        useSelector(selectBlogPage);
    const postsTranslations = useSelector(selectPostsTypeTranslations);
    const { data, next } = useSelector(selectPostForNews);

    const showAll = { type: allType, name: show_all_button };

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchBlog());
        setSelectedTag(showAll);
    }, [dispatch, show_all_button]);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchPostsForNews({ tag: selectedTag?.type === allType ? null : selectedTag?.type, page }));
    }, [dispatch, selectedTag, page, show_all_button]);

    const handleClick = item => {
        setPage(1);
        setSelectedTag(item);
    };
    const handleShowMore = () => setPage(page + 1);

    const translatedTags = tags?.map(type => ({ type, name: postsTranslations[type] }));
    const tagsData = translatedTags ? [showAll, ...translatedTags] : [];

    const handleClickButton = () => scrollToSection('subscribe-card', 100);

    return (
        <>
            <Banner
                title={title}
                image={title_background}
                buttonText={fs_button_text}
                onClickButton={handleClickButton}
            />

            <section className="container">
                <div className="inner-container">
                    <div className="news-heading">
                        <GradientText size="small">
                            <div className="max-width-760">
                                <span dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                        </GradientText>
                        <TagsFilter tags={tagsData} selectedTag={selectedTag} onClick={handleClick} />
                    </div>
                    <NewsCards posts={data} />
                    <ButtonShowMore next={next} text={show_more_button} onClick={handleShowMore} />
                </div>
            </section>
        </>
    );
};

export default News;
